import { render, staticRenderFns } from "./ChallengeTasks.vue?vue&type=template&id=6e80ec2f&scoped=true"
import script from "./ChallengeTasks.vue?vue&type=script&lang=ts"
export * from "./ChallengeTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80ec2f",
  null
  
)

export default component.exports